import locales from '../content.json'

function setUserLang() {
    let lang = window.navigator.language.slice(0, 2);

    for (const [key] of Object.entries(locales)) {
        if (key === lang) {
            document.querySelector('html').setAttribute('lang', lang);
            return lang;
        }
    }

    document.querySelector('html').setAttribute('lang', 'en');
    return 'en';
}

window.userLang = setUserLang();
